import { render } from "./ApiCsvLink.vue?vue&type=template&id=9e15fa90&scoped=true"
import script from "./ApiCsvLink.vue?vue&type=script&lang=js"
export * from "./ApiCsvLink.vue?vue&type=script&lang=js"

import "./ApiCsvLink.vue?vue&type=style&index=0&id=9e15fa90&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e15fa90"]])

export default __exports__